import styles from "./MoreNews.module.scss";
import arrowLeft from "@/assets/icons/arrowCalendarLeft.svg";
import {useLocation, useNavigate} from "react-router-dom";
import {useCurrentWidth} from "@/hooks";
import {MediaBreakPoints} from "@/resources/constants";
import { INews } from "@/redux/News/types";
import { formatDate } from "@/utils";
import { useAppSelector } from "@/redux/store";
import { NewsItem } from "../../components/NewsItem/NewsItems";

export const MoreNews = () => {
	const navigate = useNavigate();

	const location = useLocation();
	const windowWidth = useCurrentWidth();

	const { news } = useAppSelector((state) => state.news);

	const breakPoint = MediaBreakPoints.MOBILE_LARGE;
	const item: INews = location.state.item;

	const anotherNews = news.filter((newsItem) => newsItem.id !== item.id).slice(0, 3);

	const handleClick = () => {
		navigate(-1);
	};
	
	return(
		<div className={styles.wrapper}>
			{
				windowWidth > breakPoint ? (
					<div className={styles.back} onClick={handleClick}>
						<img className={styles.img} src={arrowLeft}/>

						<div className={styles.title}>
							{item.title}
						</div>
					</div>
				) : null
			}

			<div className={styles.contentWrapper}>
				<div className={styles.contentContainer}>
					<div className={styles.date}>
						{formatDate(item.created_at)}
					</div>
					<h1 className={styles.articleTitle}>
						{item.title}
					</h1>
					<div className={styles.content}>
						{item.text}
					</div>
				</div>

				<img className={styles.img_main} src={item.img_url} />
			</div>

			<div className={styles.anotherNews}>
				<div className={styles.anotherNewsTitle}>
					Другие новости
				</div>
				<div className={styles.anotherNewsContainer}>
					{
						anotherNews.map((newsItem) => (
							<NewsItem item={newsItem} key={newsItem.id} />
						))
					}
				</div>
			</div>
		</div>
	)
}